'use strict';
class NftMarketplace {
	constructor(session, contractaddress, web3providerurl) {
		this.session = session;
		this.address = contractaddress;
		
		this.web3providerurl = web3providerurl;

		this.contractpath = './contracts/erc721_marketplace_v1/IMarketplace.json';
		
		// operating variables
		this.contractinstance = null;

	}

	getAddress() {
		return this.address;
	}

	getContractPath() {
		return this.contractpath;
	}

	setContractPath(path) {
		this.contractpath = path;
		this.contractinstance = null;
	}
	
	getContractInstance() {
		if (this.contractinstance)
			return this.contractinstance;
		
		var session = this.session;
		var global = session.getGlobalObject();
		var ethnodemodule = global.getModuleObject('ethnode');

		var contractpath = this.getContractPath();
		
		this.contractinstance = ethnodemodule.getContractInstance(session, this.address, contractpath, this.web3providerurl);
		
		return this.contractinstance;
	}

	// contract methods

	//
	// read
	async getVersion() {
		var contractinstance = this.getContractInstance();

		var params = [];
	
		const valstr = await contractinstance.method_call('getVersion', params);
		
		return valstr;
	}

	async getVersionString() {
		var contractinstance = this.getContractInstance();

		var params = [];
	
		const valstr = await contractinstance.method_call('getVersionString', params);
		
		return valstr;
	}

	// fees
	async getAllFees() {
		var contractinstance = this.getContractInstance();

		var params = [];
	
		const arr = await contractinstance.method_call('getAllFees', params);
		
		return arr;
	}

	async getTokenFees(currencyaddress) {
		var contractinstance = this.getContractInstance();

		var params = [];

		params.push(currencyaddress);
	
		const arr = await contractinstance.method_call('getTokenFees', params);
		
		return arr;
	}

	// nfts
	async getNft(address, tokenId) {
		var contractinstance = this.getContractInstance();

		var params = [];

		params.push(address);
		params.push(tokenId);
	
		const val = await contractinstance.method_call('getNft', params);

		return val;
	}

	async getNftFullPrice(nftindex) {
		var contractinstance = this.getContractInstance();

		var params = [];

		params.push(nftindex);
	
		const val = await contractinstance.method_call('getNftFullPrice', params);

		return val;
	}

	async getNftCount() {
		var contractinstance = this.getContractInstance();

		var params = [];
	
		const val = await contractinstance.method_call('getNftCount', params);
		
		return val;
	}

	async getListedNfts() {
		var contractinstance = this.getContractInstance();

		var params = [];
	
		const arr = await contractinstance.method_call('getListedNfts', params);
		
		return arr;
	}

	async getMyNfts(address) {
		var contractinstance = this.getContractInstance();

		var params = [];

		params.push(address);

		
		/* const arr = await contractinstance.method_call('getMyNfts', params); */
		
		// Note: we need to by-pass contractinstance.method_call because EthereumNodeAccess
		// does not handle msg.sender that is used in the smartcontract
		var session = this.session;
		var global = session.getGlobalObject();
		
		var ethnodemodule = global.getModuleObject('ethnode');

		var ethereum_node_access_instance = ethnodemodule.getEthereumNodeAccessInstance(session);
		var web3_contract_instance = await contractinstance.activate();

		var abi = web3_contract_instance.getAbi();
		let args = (params ? params.slice(0,-1) : null);
		var abidef = ethereum_node_access_instance._getMethodAbiDefinition(abi, 'getMyNfts', args);

		var instance = web3_contract_instance['instance'];
		
		var signature = abidef.signature;

		var funcname = instance.methods[signature];


		var arr = await funcname(...params).call({from: address}, (err, res) => {
			if (err) {
				console.log('error: ' + err);
			}
			else {
				console.log('result');
			}
		})
		.catch(err => {
			console.log('catched error in EthereumNodeAccess.web3_contract_dynamicMethodCall ' + err);
		});

	
		return arr;
	}

	async getMyListedNfts(address) {
		var contractinstance = this.getContractInstance();

		var params = [];

		params.push(address);

		/* const arr = await contractinstance.method_call('getMyListedNfts', params); */
		
	
		// Note: we need to by-pass contractinstance.method_call because EthereumNodeAccess
		// does not handle msg.sender that is used in the smartcontract
		var session = this.session;
		var global = session.getGlobalObject();
		
		var ethnodemodule = global.getModuleObject('ethnode');

		var ethereum_node_access_instance = ethnodemodule.getEthereumNodeAccessInstance(session);
		var web3_contract_instance = await contractinstance.activate();

		var abi = web3_contract_instance.getAbi();
		let args = (params ? params.slice(0,-1) : null);
		var abidef = ethereum_node_access_instance._getMethodAbiDefinition(abi, 'getMyListedNfts', args);

		var instance = web3_contract_instance['instance'];
		
		var signature = abidef.signature;

		var funcname = instance.methods[signature];


		var arr = await funcname(...params).call({from: address}, (err, res) => {
			if (err) {
				console.log('error: ' + err);
			}
			else {
				console.log('result');
			}
		})
		.catch(err => {
			console.log('catched error in EthereumNodeAccess.web3_contract_dynamicMethodCall ' + err);
		});

		return arr;
	}

	//
	// transactions

	// fees
	async registerToken(currencyaddress, ethtx) {
		var contractinstance = this.getContractInstance();

		var fromaccount = ethtx.getFromAccount();
		var payingaccount = ethtx.getPayingAccount();

		payingaccount = (payingaccount ? payingaccount : fromaccount);

		var gas = ethtx.getGas();
		var gasPrice = ethtx.getGasPrice();

		var transactionuuid = ethtx.getTransactionUUID();
		var value = ethtx.getValue();


		var contractinstance = this.getContractInstance();
		var contracttransaction = contractinstance.getContractTransactionObject(payingaccount, gas, gasPrice);

		contracttransaction.setArguments(args);
		
		contracttransaction.setContractTransactionUUID(transactionuuid);
		contracttransaction.setValue(value);

		contracttransaction.setMethodName('registerToken');		
		
		var args = [];
	
		args.push(currencyaddress);
		
		contracttransaction.setArguments(args);

		return contractinstance.method_send(contracttransaction);
	}

	async createFee(name, token, feetype, 
		originatorfee, marketplacefee, distributorfee, networkfee, ethtx) {
		var contractinstance = this.getContractInstance();

		var fromaccount = ethtx.getFromAccount();
		var payingaccount = ethtx.getPayingAccount();

		payingaccount = (payingaccount ? payingaccount : fromaccount);

		var gas = ethtx.getGas();
		var gasPrice = ethtx.getGasPrice();

		var transactionuuid = ethtx.getTransactionUUID();
		var value = ethtx.getValue();


		var contractinstance = this.getContractInstance();
		var contracttransaction = contractinstance.getContractTransactionObject(payingaccount, gas, gasPrice);

		contracttransaction.setArguments(args);
		
		contracttransaction.setContractTransactionUUID(transactionuuid);
		contracttransaction.setValue(value);

		contracttransaction.setMethodName('listNft');		
		
		var args = [];
	
		args.push(name);
		args.push(token);
		args.push(feetype);
		args.push(originatorfee);
		args.push(marketplacefee);
		args.push(distributorfee);
		args.push(networkfee);
		
		contracttransaction.setArguments(args);

		return contractinstance.method_send(contracttransaction);
	}

	// nfts
	async listNft(tokenaddress, nftid, price, currencyaddress, feeIndex, originator, ethtx) {
		var contractinstance = this.getContractInstance();

		var fromaccount = ethtx.getFromAccount();
		var payingaccount = ethtx.getPayingAccount();

		payingaccount = (payingaccount ? payingaccount : fromaccount);

		var gas = ethtx.getGas();
		var gasPrice = ethtx.getGasPrice();

		var transactionuuid = ethtx.getTransactionUUID();
		var value = ethtx.getValue();


		var contractinstance = this.getContractInstance();
		var contracttransaction = contractinstance.getContractTransactionObject(payingaccount, gas, gasPrice);

		contracttransaction.setArguments(args);
		
		contracttransaction.setContractTransactionUUID(transactionuuid);
		contracttransaction.setValue(value);

		contracttransaction.setMethodName('listNft');		
		
		var args = [];
	
		args.push(tokenaddress);
		args.push(nftid);
		args.push(price);
		args.push(currencyaddress);
		args.push(feeIndex);
		args.push(originator);
		
		contracttransaction.setArguments(args);

		return contractinstance.method_send(contracttransaction);
	}

	async delistNft(nftindex, originator, ethtx) {
		var contractinstance = this.getContractInstance();

		var fromaccount = ethtx.getFromAccount();
		var payingaccount = ethtx.getPayingAccount();

		payingaccount = (payingaccount ? payingaccount : fromaccount);

		var gas = ethtx.getGas();
		var gasPrice = ethtx.getGasPrice();

		var transactionuuid = ethtx.getTransactionUUID();
		var value = ethtx.getValue();


		var contractinstance = this.getContractInstance();
		var contracttransaction = contractinstance.getContractTransactionObject(payingaccount, gas, gasPrice);

		contracttransaction.setArguments(args);
		
		contracttransaction.setContractTransactionUUID(transactionuuid);
		contracttransaction.setValue(value);

		contracttransaction.setMethodName('delistNft');		
		
		var args = [];
	
		args.push(nftindex);
		args.push(originator);
		
		contracttransaction.setArguments(args);

		return contractinstance.method_send(contracttransaction);
	}

	async buyNft(nftindex, distributor, ethtx) {
		var contractinstance = this.getContractInstance();

		var fromaccount = ethtx.getFromAccount();
		var payingaccount = ethtx.getPayingAccount();

		payingaccount = (payingaccount ? payingaccount : fromaccount);

		var gas = ethtx.getGas();
		var gasPrice = ethtx.getGasPrice();

		var transactionuuid = ethtx.getTransactionUUID();
		var value = ethtx.getValue();


		var contractinstance = this.getContractInstance();
		var contracttransaction = contractinstance.getContractTransactionObject(payingaccount, gas, gasPrice);

		contracttransaction.setArguments(args);
		
		contracttransaction.setContractTransactionUUID(transactionuuid);
		contracttransaction.setValue(value);

		contracttransaction.setMethodName('buyNft');		
		
		var args = [];
	
		args.push(nftindex);
		args.push(distributor);
		
		contracttransaction.setArguments(args);

		return contractinstance.method_send(contracttransaction);
	}

	async resellNft(nftindex, price, originator, ethtx) {
		var contractinstance = this.getContractInstance();

		var fromaccount = ethtx.getFromAccount();
		var payingaccount = ethtx.getPayingAccount();

		payingaccount = (payingaccount ? payingaccount : fromaccount);

		var gas = ethtx.getGas();
		var gasPrice = ethtx.getGasPrice();

		var transactionuuid = ethtx.getTransactionUUID();
		var value = ethtx.getValue();


		var contractinstance = this.getContractInstance();
		var contracttransaction = contractinstance.getContractTransactionObject(payingaccount, gas, gasPrice);

		contracttransaction.setArguments(args);
		
		contracttransaction.setContractTransactionUUID(transactionuuid);
		contracttransaction.setValue(value);

		contracttransaction.setMethodName('resellNft');		
		
		var args = [];
	
		args.push(nftindex);
		args.push(price);
		args.push(originator);
		
		contracttransaction.setArguments(args);

		return contractinstance.method_send(contracttransaction);
	}

	// static
	static getObject() {
		if (NftMarketplace.instance)
			return NftMarketplace.instance;
		
		NftMarketplace.instance = new NftMarketplace();

		return NftMarketplace.instance;
	}

}


if ( typeof window !== 'undefined' && typeof window.GlobalClass !== 'undefined' && window.GlobalClass ) {
	var _GlobalClass = window.GlobalClass;
}
else if (typeof window !== 'undefined') {
	var _GlobalClass = ( window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}
else if (typeof global !== 'undefined') {
	// we are in node js
	var _GlobalClass = ( global && global.simplestore && global.simplestore.Global ? global.simplestore.Global : null);
}

_GlobalClass.registerModuleClass('common', 'NftMarketplace', NftMarketplace);

